import advanceReactCer from '../images/advanceReactCer.PNG'
import tryHackMeCer from '../images/tryHackMeCer.PNG'
import frontCarer from '../images/frontCarer.PNG'
import frontCareer2 from '../images/frontCareer2.png'
import threejs from '../images/threejs.png'
const data = [
    {
        id:1,
        img:tryHackMeCer,
        title:'Pre Security Learning Path',
        url:'https://tryhackme-certificates.s3-eu-west-1.amazonaws.com/THM-STUVDGLW8M.png',
        date:'2022/Jan/1'
    },
    {
        id:2,
        img:advanceReactCer,
        title:'Advanced React',
        url:'https://scrimba.com/certificate/uNbKDvS5/greact',
        date:'2022/Jul/30'
    },
        {
        id:3,
        img:frontCarer,
        title:'The Frontend Career Path',
        url:'https://scrimba.com/certificate/uNbKDvS5/gfrontend',
        date:'2023/Aug/7'
    },
        {
        id:4,
        img:frontCareer2,
        title:'The Frontend Career Path 2',
        url:'https://scrimba.com/certificate-cert2uNjfK9m1kjZ8rY7cHYBTKLUHYcSxEUegPi',
        date:'2024/Oct/11'
    },
    {
        id: 5,
        img: threejs,
        title: 'Three.js Journey',
        url: 'https://threejs-journey.com/certificate/view/43493',
        date: '2025/Mar/6'
    }
]
export default data